import rentPaymentPeriods from '@/constants/price/rent-payment-periods'

export default {
  [rentPaymentPeriods.DAILY]: 'priceTag.dailyRentPayment',
  [rentPaymentPeriods.WEEKLY]: 'priceTag.weeklyRentPayment',
  [rentPaymentPeriods.MONTHLY]: 'priceTag.monthlyRentPayment',
}
